Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = locationEquals;

var _deepEqual = require("deep-equal");

var _deepEqual2 = _interopRequireDefault(_deepEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function locationEquals(a, b) {
    if (!a && !b) {
        return true;
    }
    if (a && !b || !a && b) {
        return false;
    }

    return a.pathname === b.pathname && a.search === b.search && (0, _deepEqual2.default)(a.state, b.state);
}